import { Link } from "react-router-dom";

export default function ServicesHero() {
  return (
    <section className="relative w-full min-h-[70vh] overflow-hidden flex items-center pt-40 md:pt-44 pb-16">
      <img
        src="/images/hero/engineering.webp"
        alt="ISMAN Engineering Services — Industrial Equipment"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-cyan-950/90 via-cyan-900/75 to-teal-900/50"></div>

      {/* Top accent line */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-400 via-teal-400 to-cyan-400"></div>

      {/* Breadcrumb */}
      <div className="absolute top-32 md:top-[136px] left-6 md:left-16 z-10 flex items-center gap-2 text-white/60 text-xs">
        <Link to="/" className="hover:text-cyan-300 transition-colors cursor-pointer">Home</Link>
        <i className="ri-arrow-right-s-line"></i>
        <span className="text-cyan-300 font-medium">Our Services</span>
      </div>

      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-6 md:px-16 w-full grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* ── Left: Text content ── */}
          <div>
            <span className="text-cyan-300 text-xs font-semibold uppercase tracking-widest mb-4 block">
              ISMAN Company — Engineering Division
            </span>
            <h1 className="text-white text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-extrabold leading-tight uppercase tracking-tight mb-6">
              Our <span className="text-cyan-400">7 Core</span><br />Engineering Services
            </h1>
            <p className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl mb-10">
              From industrial machinery installation to full plant automation — ISMAN COMPANY delivers
              end-to-end engineering solutions trusted by manufacturers, healthcare providers and
              commercial operators across Kenya and East Africa.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="#services-grid"
                onClick={(e) => { e.preventDefault(); document.querySelector("#services-grid")?.scrollIntoView({ behavior: "smooth" }); }}
                className="bg-cyan-600 hover:bg-cyan-500 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
              >
                Explore Services
              </a>
              <Link
                to="/#contact"
                className="border border-white/40 hover:border-cyan-400 hover:text-cyan-300 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
              >
                Get a Quote
              </Link>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-8 mt-12">
              {[
                { value: "7", label: "Core Services" },
                { value: "15+", label: "Years Experience" },
                { value: "500+", label: "Projects Done" },
                { value: "200+", label: "Happy Clients" },
              ].map((stat) => (
                <div key={stat.label}>
                  <p className="text-cyan-400 text-2xl font-extrabold">{stat.value}</p>
                  <p className="text-white/60 text-xs uppercase tracking-wider mt-0.5">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ── Right: Uploaded showcase image ── */}
          <div className="hidden lg:flex justify-end items-center">
            <div className="relative w-[420px] h-[340px]">
              {/* Glow ring behind image */}
              <div className="absolute -inset-3 rounded-2xl bg-cyan-400/20 blur-xl"></div>
              {/* Cyan border frame */}
              <div className="absolute -inset-1 rounded-2xl border border-cyan-400/40"></div>
              <img
                src="/images/about/hvac-plant.webp"
                alt="ISMAN Engineering Services"
                className="w-full h-full object-cover object-center rounded-2xl relative z-10"
              />
              {/* Bottom label badge */}
              <div className="absolute bottom-4 left-4 right-4 z-20 bg-cyan-950/80 backdrop-blur-sm rounded-lg px-4 py-2 flex items-center gap-2">
                <div className="w-2 h-2 flex items-center justify-center">
                  <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse block"></span>
                </div>
                <span className="text-white/90 text-xs font-semibold uppercase tracking-wider">Premium Engineering Solutions</span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
